import { DatePipe, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { everyRequiestTokenInterceptor } from '@core/interceptors/everyRequiestToken.interceptor';
import { httpErrorHandlingInterceptor } from '@core/interceptors/error-handling/http-error-handling.interceptor';
import { LoadingModule } from '@core/loading';
import { LoaderComponent } from '@core/loading/loader/loader.component';
import { TicketingComponent } from '@page/ticketing/ticketing/ticketing.component';
import { SharedModule } from '@shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { LOCATION_INITIALIZER } from '@core/location-required/location-required.factory';
import { ENCRYPTION_INITIALIZER } from '@core/encryption-module/encryption.factory';
import { newAuthHeaderInterceptor } from '@core/interceptors/NewAuthHeader.interceptor';
import { encryptionInterceptor } from '@core/encryption-module/encryption.interceptor';
import { attachCancelInterceptor } from '@core/interceptors/error-handling/abort-ongoing-requests/attachAbortSignal.interceptor';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { locationInterceptor } from '@core/location-required/location.interceptor';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        ToastrModule.forRoot(),
        BsDatepickerModule.forRoot(),
        LayoutComponent,
        TicketingComponent,
        LoadingModule,
        LoaderComponent
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        LOCATION_INITIALIZER,
        ENCRYPTION_INITIALIZER,
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([everyRequiestTokenInterceptor, newAuthHeaderInterceptor, attachCancelInterceptor, httpErrorHandlingInterceptor, encryptionInterceptor])
        ),
        DatePipe,
        provideNgxSkeletonLoader({
            theme: {
                extendsFromRoot: true,
                height: '30px',
            },
        }),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
